<template>
  <div class="comp">
    <div class="grid site404 comp-inner">
      <div>
        <h1>404</h1>
        <a href="https://ombrelleria.com" class="btn red">Ombrelleria</a>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
  name: 'Site404',
  // mixins: [helper],
  props: {
    // hotel: Object
  },
  data () {
	return {
		changes: false
	}
  },
  methods: {
	show (section) {
		// console.log(section)
		this.$emit('open', section)
	},
	save () {
		console.log('save')
		// this.$store.dispatch('hotels/updateHotel', this.hotel)
	}
  },
  filters: {

  },
  watch: {

  },
  computed: {

  },
  beforeMount () {

  },
  beforeDestroy () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
